import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CustomCursor = () => {
	const [cursorSize, setCursorSize] = useState('small');
	const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
	const location = useLocation();

	useEffect(() => {
		const handleMouseEnter = (event) => {
			const { target } = event;
			if (
				target.classList.contains('hover-cursor') ||
				target.classList.contains('swiper-button-next') ||
				target.classList.contains('swiper-button-prev') ||
				target.tagName === 'A' ||
				target.tagName === 'BUTTON'
			) {
				setCursorSize('large');
			}
		};

		const handleMouseLeave = (event) => {
			const { target } = event;
			if (
				target.classList.contains('hover-cursor') ||
				target.tagName === 'A' ||
				target.tagName === 'BUTTON'
			) {
				setCursorSize('small');
			}
		};

		const handleMouseMove = (event) => {
			setCursorPosition({ x: event.clientX, y: event.clientY });
		};

		// Nascondi il cursore di sistema
		document.body.style.cursor = 'none';

		document.addEventListener('mousemove', handleMouseMove);
		document.addEventListener('mouseover', handleMouseEnter);
		document.addEventListener('mouseout', handleMouseLeave);

		return () => {
			document.removeEventListener('mousemove', handleMouseMove);
			document.removeEventListener('mouseover', handleMouseEnter);
			document.removeEventListener('mouseout', handleMouseLeave);

			// Ripristina il cursore di sistema
			document.body.style.cursor = 'auto';
		};
	}, []);

	useEffect(() => {
		setCursorSize('small');
	}, [location]);

	return (
		<div
			className={`custom-cursor ${cursorSize}`}
			style={{
				left: `${cursorPosition.x}px`,
				top: `${cursorPosition.y}px`,
			}}
		></div>
	);
};

export default CustomCursor;
